// extracted by mini-css-extract-plugin
export default {"description":"AccessControlView_description__Ne7+L","divider":"AccessControlView_divider__4Wn5g"};